import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "pagination justify-content-center justify-content-md-end mb-0" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  key: 0,
  class: "page-item disabled"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", {
    "aria-label": "Page navigation",
    class: _normalizeClass({ 'pagination-sm': _ctx.isSmall })
  }, [
    _createElementVNode("ul", _hoisted_1, [
      _createElementVNode("li", {
        class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === 1 }])
      }, [
        _createElementVNode("button", {
          class: "page-link",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handlePageChange(_ctx.currentPage - 1))),
          disabled: _ctx.currentPage === 1
        }, _cache[2] || (_cache[2] = [
          _createElementVNode("i", { class: "icon ion-ios-arrow-back" }, null, -1)
        ]), 8, _hoisted_2)
      ], 2),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedPages, (item) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: item }, [
          (item === '...')
            ? (_openBlock(), _createElementBlock("li", _hoisted_3, _cache[3] || (_cache[3] = [
                _createElementVNode("span", { class: "page-link" }, "...", -1)
              ])))
            : (_openBlock(), _createElementBlock("li", {
                key: 1,
                class: _normalizeClass(["page-item", { active: _ctx.currentPage === item }])
              }, [
                _createElementVNode("button", {
                  class: "page-link",
                  onClick: ($event: any) => (_ctx.handlePageChange(item))
                }, _toDisplayString(item), 9, _hoisted_4)
              ], 2))
        ], 64))
      }), 128)),
      _createElementVNode("li", {
        class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === _ctx.totalPages }])
      }, [
        _createElementVNode("button", {
          class: "page-link",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handlePageChange(_ctx.currentPage + 1))),
          disabled: _ctx.currentPage === _ctx.totalPages
        }, _cache[4] || (_cache[4] = [
          _createElementVNode("i", { class: "icon ion-ios-arrow-forward" }, null, -1)
        ]), 8, _hoisted_5)
      ], 2)
    ])
  ], 2))
}